import React, { Component } from 'react'
import Modal from 'react-modal'
import { formatDayForEventStub, formatDateForEventStub, formatTimeForEventStub } from '../../../helpers.js'

class AdminEvent extends Component {
  constructor() {
    super()
    this.state = {
      modalIsOpen: false
    }
  }

  openModal = () => {
    this.setState({modalIsOpen: true})
  }

  closeModal = () => {
    this.setState({modalIsOpen: false})
  }

  renderBodyText = (event) => {
    return {__html: event.bodytext}
  }

  render() {
		let formattedDay = formatDayForEventStub(this.props.fulldate)
		let formattedDate = formatDateForEventStub(this.props.fulldate)
		let formattedStart = formatTimeForEventStub(this.props.fulldate)
    return (
      <article className="eventHover w-100 mb3 bg-white card flex flex-row pointer" onClick={() => this.openModal()}>
        <div className="eventStub bg-gray flex-column flex-none centerize pa2 w-30 w4-ns">
					<div className="f5 f4-ns tc near-white open-sans-cond dn db-ns">{formattedDay}</div>
					<div className="f3 f1-ns tc near-white pathway lh-solid">{formattedDate}</div>
					<div className="f5 f4-ns tc near-white open-sans-cond">{formattedStart}</div>
        </div>
        <div className="eventHeadline pathway f4 f2-ns flex-auto pa2 pa3-ns self-center" onClick={() => this.openModal()}>
          {this.props.headline}
        </div>
        <div className="pathway f2 flex-none flex flex-column flex-row-ns items-center ph2 ph3-ns pv2 pv0-ns">
          <a className="eventLink link pathway card pointer dim bg-dark-gray pa2 f4 f3-m f2-l tc near-white" href={this.props.link} target="_blank">LINK</a>
        </div>
        <div>
          <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            contentLabel="Modal"
            className={{
							base: 'eventModal w-90 w-two-thirds-m w-50-l z-3',
							afterOpen: '',
							beforeClose: ''
						}}
            overlayClassName={{
							base: 'eventModalOverlay z-2',
							afterOpen: '',
							beforeClose: ''
						}}
						ariaHideApp={false}
          >
						<article className="bg-white card flex flex-column">
              <div className="bg-gray pathway near-white ph3 pv2 flex flex-row items-center justify-between">
                <div className="f2 f1-ns tc">
									{formattedDay} {formattedDate}
								</div>
                <div className="flex flex-row items-center">
                  <div className="f3 f2-ns tc">{formattedStart}</div>
                  <div className="pointer dim bg-dark-gray near-white br-50 pa2 ml3"
                       onClick={ () => this.closeModal()}>
                    <i className="fa fa-times lh-tight pa1" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <div className="bg-white pathway f2 f2-m f1-l ph3 pt3">
                {this.props.headline}
              </div>
              <div className="bg-white droid f5 lh-copy pa3">
                <div dangerouslySetInnerHTML={this.renderBodyText(this.props.event)} />
              </div>
              <div className="bg-white ph3 pb3 flex flex-column">
                <a href={this.props.link} target="_blank" className="no-underline">
                  <div className="link pathway card pointer dim bg-dark-gray pa2 f4 f3-m f2-l tc near-white w-100 mb3">
                    LINK
                  </div>
                </a>
								<div className="dib card pointer dim bg-very-red pa2 tc"
										 onClick={() => {this.props.deleteEvent(this.props.event)}} >
									<i className="fa fa-trash f2 near-white" 
										aria-hidden="true" 
									/>
								</div>
              </div>
						</article>
          </Modal>
        </div>
      </article>
    )
  }
}

export default AdminEvent


// WEBPACK FOOTER //
// ./src/components/admin/multi/AdminEvent.js